import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Share2, Loader2 } from "lucide-react";

// Opens the phone's share sheet (Instagram, WhatsApp, …) with the exported MP4. Falls back to download.
export const ShareVideoButton = ({ url, name = "caption-motion.mp4", autoPrompt = false }) => {
  const [file, setFile] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => {
    let off = false;
    fetch(url, { credentials: "include" }).then((r) => r.blob()).then((b) => { if (!off) setFile(new File([b], name, { type: "video/mp4" })); }).catch(() => !off && setErr(true));
    return () => { off = true; };
  }, [url, name]);
  const canShare = !!(file && navigator.canShare?.({ files: [file] }));
  const share = async () => {
    if (!file) return;
    if (!canShare) {
      const a = document.createElement("a"); a.href = URL.createObjectURL(file); a.download = name; a.click();
      toast.message("Sharing isn't available in this browser — the video was saved. Open Instagram or WhatsApp and pick it from your gallery.");
      return;
    }
    try { await navigator.share({ files: [file], title: "My Caption Motion video", text: "Made with Caption Motion" }); }
    catch (e) { if (e.name !== "AbortError") toast.error("Couldn't open sharing"); }
  };
  if (err) return null;
  return (
    <button onClick={share} disabled={!file} data-testid="share-video-btn"
      className={`flex w-full items-center justify-center gap-2 rounded-full py-3 text-sm font-bold text-white transition-transform hover:scale-[1.01] disabled:opacity-60 ${autoPrompt ? "animate-pulse" : ""}`}
      style={{ background: "linear-gradient(90deg,#E1306C,#F77737 55%,#25D366)" }}>
      {file ? <Share2 size={16} /> : <Loader2 size={16} className="animate-spin" />} {file ? (canShare ? "Share to Instagram, WhatsApp…" : "Save & share") : "Preparing to share…"}
    </button>
  );
};
